"use client";

import { useTranslations } from "next-intl";

interface VideoShowcaseProps {
	title?: string;
	description?: string;
	useYouTube?: boolean;
	youtubeId?: string;
	localVideoSrc?: string;
	posterImage?: string;
}

export function VideoShowcase({
	title,
	description,
	useYouTube = true,
	youtubeId = 'qq3QcI6j4Y8',
	localVideoSrc = "images/spyglasses-teaser-video.mp4",
	posterImage = "images/spyglasses-teaser-video-poster.webp"
}: VideoShowcaseProps) {
	const t = useTranslations();

	const displayTitle = title || t("marketing.videoShowcase.title");
	const displayDescription = description || t("marketing.videoShowcase.description");

	return (
		<section className="py-16">
			<div className="container">
				<div className="mx-auto max-w-4xl">
					<div className="text-center mb-8">
						<h2 className="text-3xl font-bold mb-4">
							{displayTitle}
						</h2>
						<p className="text-foreground/60 text-lg max-w-2xl mx-auto">
							{displayDescription}
						</p>
					</div>

				<div className="relative rounded-2xl overflow-hidden border bg-card/50 shadow-lg dark:shadow-foreground/10">
					{useYouTube && youtubeId ? (
						// YouTube Embed
						<div className="relative aspect-video">
							<iframe
								src={`https://www.youtube.com/embed/${youtubeId}?rel=0&modestbranding=1&controls=1&showinfo=0`}
								title="Spyglasses Demo Video"
								allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
								allowFullScreen
								className="absolute inset-0 w-full h-full"
							/>
						</div>
					) : (
						// Local Video
						<div className="relative aspect-video">
							<video
								controls
								poster={posterImage}
								className="w-full h-full object-cover"
								preload="metadata"
							>
								<source src={localVideoSrc} type="video/mp4" />
								Your browser does not support the video tag.
							</video>
						</div>
					)}
				</div>
				</div>
			</div>
		</section>
	);
} 